define('vspot-angular/services/activity-type-service',[], function () {
    'use strict';

    return ['resources.ActivityType', function (ActivityType) {
        return {
            /*
             * Get a list of all the activity types.
             * @param {bool} include_job_titles = should we include job title data? Defaults to false
             *
             * @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: {
             *                      loading: boolean, // Is the object actively getting data
             *                      status: boolean, // true if it worked, false on error
             *                      data: array_of_types
             *                  }
             */
            query: function(include_job_titles) {
                if( global_helper.blank( include_job_titles ) ) {
                    include_job_titles = false;
                }
                return ActivityType.query({
                    'include_job_titles': include_job_titles
                });
            }
        };
    }];
});

